import { render, staticRenderFns } from "./PackageRegistration.vue?vue&type=template&id=691c45c4&scoped=true"
import script from "./PackageRegistration.vue?vue&type=script&lang=js"
export * from "./PackageRegistration.vue?vue&type=script&lang=js"
import style0 from "./PackageRegistration.vue?vue&type=style&index=0&id=691c45c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691c45c4",
  null
  
)

export default component.exports